export const API_BASE_URL = 'https://api.1browser.com';
// export const API_BASE_URL = 'http://localhost:3002';
export const API_DOCS_URL = `${API_BASE_URL}/docs`;
export const API_OPENAPI_URL = `${API_BASE_URL}/docs-json`; 